module.exports = __webpack_public_path__ + "img/comment_img4.851646f3.jpg";